import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=85c5bb0e&"
import script from "./OfferCard.vue?vue&type=script&lang=ts&"
export * from "./OfferCard.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=85c5bb0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports